import { trackClick } from '../lib/analytics';
import React from "react";

function FeatureSectionLandingPage() {
  return (
    <section id="home" className="relative flex min-h-screen items-center bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-800 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-accent-300 dark:bg-accent-900 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-3xl opacity-20 animate-blob"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-accent-400 dark:bg-accent-800 rounded-full mix-blend-multiply dark:mix-blend-soft-light filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
      </div>

      <div className="relative mx-auto grid w-full max-w-screen-xl px-4 pb-16 pt-28 lg:grid-cols-12 lg:gap-12 lg:py-24 lg:pt-32 xl:gap-16">
        <div className="mr-auto place-self-center lg:col-span-7 animate-fade-in">
          <h1 className="mb-6 max-w-2xl text-4xl font-extrabold leading-tight tracking-tight md:text-5xl xl:text-6xl">
            <span className="bg-gradient-to-r from-accent-600 via-accent-400 to-accent-600 bg-clip-text text-transparent dark:from-accent-300 dark:via-accent-200 dark:to-accent-300">
              Building Digital
            </span>
            <br />
            <span className="text-gray-900 dark:text-white">
              Products & Brands
            </span>
          </h1>

          <p className="mb-8 max-w-2xl text-gray-900 dark:text-white md:text-2xl font-bold leading-tight">
            Our Custom Approach
          </p>

          <p className="mb-8 max-w-2xl text-gray-600 dark:text-gray-300 md:text-lg lg:text-xl leading-relaxed">
            Every business is unique, and so are its digital needs. That's why our approach is tailored to your specific goals and objectives.
          </p>

          <p className="mb-8 max-w-2xl text-gray-600 dark:text-gray-300 md:text-lg leading-relaxed">
            We take the time to understand your brand, your target audience, and your vision for the future. Then, we develop custom strategies that blend creativity, innovation, and technical expertise to deliver results you can see and measure.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              onClick={() => trackClick('Get Started', 'hero')}
              className="inline-flex items-center justify-center px-6 py-3 text-base font-semibold text-white bg-gradient-to-r from-accent-500 to-accent-700 rounded-lg hover:from-accent-600 hover:to-accent-800 focus:ring-4 focus:ring-accent-300 dark:focus:ring-accent-900 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              aria-label="Get started with SDS Deliver IO"
            >
              Get Started
              <svg className="ml-2 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </a>

            <a
              href="https://github.com/sdsdeliverio"
              onClick={() => trackClick('View GitHub', 'hero', 'https://github.com/sdsdeliverio')}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-6 py-3 text-base font-medium text-gray-900 dark:text-white border-2 border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 transition-all duration-300"
              aria-label="View SDS Deliver IO GitHub"
            >
              <svg
                className="mr-2 h-5 w-5"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
              </svg>
              View GitHub
            </a>
          </div>
        </div>

        <div className="hidden lg:col-span-5 lg:mt-0 lg:flex items-center justify-center animate-slide-in-right">
          <img
            src="/images/hero.png"
            alt="Digital products and technology illustration"
            className="w-full h-auto rounded-lg transform hover:scale-105 transition-transform duration-300"
            loading="eager"
          />
        </div>
      </div>
    </section>
  );
}

export default FeatureSectionLandingPage;
